export default "__VITE_ASSET__BIwuEeHL__"